import React from 'react';
import { BarChart3, Users, CircleDot, Flag, CreditCard, Settings } from 'lucide-react';

function AdminSidebar({ activeTab, setActiveTab, onClose }) {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', Icon: BarChart3 },
    { id: 'users', label: 'Usuários', Icon: Users },
    { id: 'matches', label: 'Partidas', Icon: CircleDot },
    { id: 'teams', label: 'Seleções', Icon: Flag },
    { id: 'payments', label: 'Pagamentos', Icon: CreditCard },
    { id: 'settings', label: 'Configurações', Icon: Settings }
  ];

  return (
    <div className="w-64 bg-primary text-white min-h-screen">
      <div className="p-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl font-bold">Bolão Admin</h2>
          {onClose && (
            <button
              onClick={onClose}
              className="md:hidden p-1 rounded-md hover:bg-primary-dark transition focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
              aria-label="Fechar menu"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
        <nav>
          <ul className="space-y-2">
            {menuItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => setActiveTab(item.id)}
                  className={`w-full text-left px-4 py-3 rounded flex items-center transition focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none ${{
                    dashboard: 'bg-tertiary hover:bg-tertiary-dark',
                    users: 'bg-purple-600 hover:bg-purple-700',
                    matches: 'bg-secondary-dark hover:bg-yellow-700',
                    teams: 'bg-indigo-600 hover:bg-indigo-700',
                    payments: 'bg-red-600 hover:bg-red-700',
                    settings: 'bg-gray-600 hover:bg-gray-700'
                  }[item.id] || ''} ${{
                    true: 'bg-gray-700'
                  }[activeTab === item.id]}`}
                >
                  <item.Icon className="w-5 h-5 mr-3" aria-hidden="true" />
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default AdminSidebar;